export default __webpack_public_path__ + "static/media/B180.cbc35007.png";